// extracted by mini-css-extract-plugin
module.exports = {"sharaLinkStyle":"_1HqikR_JGtlq455gp9kXuK"};